import React from 'react';
import { Mutation } from 'react-apollo';

import { UPDATE_CHURCH_WEBSITE_MUTATION } from 'services/graphql/mutations';

import AccountForm from '../AccountForm';
import Label from 'components/common/form/Label';
import FormControl from 'components/common/form/FormControl';
import InputDynamic from 'components/common/form/inputs/dynamic/InputDynamic';
import Input from 'components/common/form/inputs/Input';
import { ToastContext } from 'components/common/ToastContainer';

import accountStyles from '../../account.module.css';

export class ChurchWebsiteForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit() {
    let website = this.websiteInput.value;
    let id = this.props.acctData.adminOf.id;
    let updateResponse;

    try {
      updateResponse = await this.props.updateChurchWebsiteMutation({
        variables: { id, website },
        optimisticResponse: {
          updateChurchWebsite: {
            __typename: 'Church',
            id,
            website
          }
        }
      });
      this.props.showToast({
        type: 'success',
        content: 'Church Website successfully updated!'
      });
    } catch (e) {
      updateResponse = e;
      this.props.showToast({
        type: 'error',
        content: 'There was an issue saving. Please try again later'
      });
    }

    return updateResponse;
  }

  render() {
    return (
      <AccountForm
        handleSubmit={this.handleSubmit}
        render={({ editable, handleMount }) => (
          <FormControl labelTop={true} className={accountStyles.inputContainer}>
            <Label htmlFor="website">Website</Label>
            <InputDynamic
              displayInput={editable}
              value={this.props.acctData.adminOf.website}
            >
              <Input
                defaultValue={this.props.acctData.adminOf.website}
                id="website"
                refFn={input => {
                  this.websiteInput = input;
                }}
                mountFn={() => handleMount(this.websiteInput)}
              />
            </InputDynamic>
          </FormControl>
        )}
      />
    );
  }
}

export default class ChurchWebsiteFormWithData extends React.Component {
  render() {
    return (
      <ToastContext.Consumer>
        {({ showToast }) => (
          <Mutation mutation={UPDATE_CHURCH_WEBSITE_MUTATION}>
            {updateChurchWebsiteMutation => (
              <ChurchWebsiteForm
                updateChurchWebsiteMutation={updateChurchWebsiteMutation}
                showToast={showToast}
                {...this.props}
              />
            )}
          </Mutation>
        )}
      </ToastContext.Consumer>
    );
  }
}
